import CircularProgress from '@mui/material/CircularProgress';
import * as React from 'react';

export default function MemreLoading() {
  return <CircularProgress color="primary" size={20} />;
}
